import i18n from "i18next";
import { initReactI18next } from "react-i18next";

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translations: {
          welcome: "Welcome to CUS",
        }
      },
      fr: {
        translations: {
          welcome: "Bienvenue à CUS",
        }
      },
    },
    lng: localStorage.getItem("currentLang") || "en",
    fallbackLng: "en",
    // lng: "en",
    // fallbackLng: "en",
    ns: ["translations"],
    defaultNS: "translations",
    keySeparator: false,
    interpolation: {
      escapeValue: false,
      formatSeparator: ",",
    },
    react: {
      wait: true
    }
  });

export default i18n;
